module.exports = __webpack_public_path__ + "img/问卷调查.243dea1b.png";